import React, { useState } from "react";
import { BaseBox, BaseTypography } from "../../../Common/UI/exports";

const SETTINGS_CARDS = [
  {
    id: "personas",
    title: "Personas",
    desc: "Manage the AI personas used across chat and automation flows.",
    icon: "🎭",
  },
];

function AISettings() {
  const [selectedCard, setSelectedCard] = useState("");

  const handleCardClick = (cardId) => {
    setSelectedCard(cardId);
    // No destination yet; wire up once a dedicated Personas page exists.
  };

  return (
    <BaseBox
      sx={{
        textAlign: "center",
        margin: "0",
        maxWidth: "900px",
        padding: 2,
      }}
    >
      <BaseTypography sx={{ mb: 3, fontWeight: 600, fontSize: "1.5rem" }}>
        AI Settings
      </BaseTypography>

      <BaseBox
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
          gap: 3,
          justifyContent: "center",
        }}
      >
        {SETTINGS_CARDS.map((card) => (
          <BaseBox
            key={card.id}
            onClick={() => handleCardClick(card.id)}
            sx={{
              p: 3,
              borderRadius: "16px",
              backgroundColor:
                selectedCard === card.id ? "#e0f7fa" : "background.paper",
              boxShadow:
                selectedCard === card.id
                  ? "0 6px 14px rgba(0,0,0,0.25)"
                  : "0 3px 8px rgba(0,0,0,0.12)",
              cursor: "pointer",
              transition: "all 0.3s ease",
              textAlign: "center",
              "&:hover": {
                transform: "translateY(-5px)",
                boxShadow: "0 8px 16px rgba(0,0,0,0.2)",
              },
            }}
          >
            <BaseTypography sx={{ fontSize: "2rem" }}>
              {card.icon}
            </BaseTypography>
            <BaseTypography sx={{ fontWeight: 600, mt: 1 }}>
              {card.title}
            </BaseTypography>
            <BaseTypography
              sx={{
                color: "text.secondary",
                fontSize: "0.9rem",
                mt: 0.5,
              }}
            >
              {card.desc}
            </BaseTypography>
          </BaseBox>
        ))}
      </BaseBox>
    </BaseBox>
  );
}

export default AISettings;
